import React from 'react';
import { Link } from 'react-router-dom';

const ArtrixTermsOfService: React.FC = () => {
  return (
    <section className="section">
      <div className="container">
        <div style={{ marginBottom: '2rem' }}>
          <Link 
            to="/" 
            style={{ 
              color: 'var(--accent-color)', 
              textDecoration: 'none',
              fontSize: '1rem',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            ← Back to Home
          </Link>
        </div>
        
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{ 
            fontSize: '2.5rem', 
            fontWeight: '700',
            marginBottom: '1rem',
            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            Artrix Terms of Service
          </h1>
          <div className="section-divider"></div>
        </div>

        <div style={{ 
          maxWidth: '800px', 
          margin: '0 auto',
          lineHeight: '1.6',
          fontSize: '1rem'
        }}>
          <p style={{ marginBottom: '2rem', fontSize: '1rem' }}>
            <strong>Effective Date:</strong> October 10, 2025<br/>
            <strong>Last Updated:</strong> October 10, 2025
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>Agreement to Terms</h2>
          
          <p style={{ marginBottom: '2rem' }}>
            By downloading, installing, or using Artrix ("the App"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, do not use the App.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>1. Service Description</h2>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>1.1 What Artrix Provides</h3>
          <p style={{ marginBottom: '0.5rem' }}>Artrix is an AI-powered art generation app that allows you to:</p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Generate unique artwork using OpenAI's DALL-E 3 technology</li>
            <li>Save and organize your creations in a personal gallery</li>
            <li>Share your artwork publicly with the Artrix community</li>
            <li>Customize images with various art styles and settings</li>
            <li>Create and maintain a user profile</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>1.2 Service Availability</h3>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>The App is provided "as is" and "as available"</li>
            <li>We strive for 99.9% uptime but don't guarantee uninterrupted service</li>
            <li>Features may be updated, modified, or discontinued without notice</li>
            <li>We reserve the right to limit usage during high-demand periods</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>1.3 Age Requirements</h3>
          <p style={{ marginBottom: '0.5rem' }}>You must be:</p>
          <ul style={{ marginBottom: '2rem', paddingLeft: '1.5rem' }}>
            <li>At least 13 years old to use Artrix</li>
            <li>At least 18 years old (or age of majority) to make purchases</li>
            <li>Able to form a binding contract under applicable law</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>2. User Accounts and Profiles</h2>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>2.1 Account Creation</h3>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>No email or password required for basic use</li>
            <li>Optional username creation for public gallery features</li>
            <li>You are responsible for maintaining account confidentiality</li>
            <li>One account per person/device</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>2.2 Username Requirements</h3>
          <p style={{ marginBottom: '0.5rem' }}>Your username must NOT:</p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Impersonate others or entities</li>
            <li>Contain offensive, vulgar, or inappropriate language</li>
            <li>Violate trademarks or intellectual property rights</li>
            <li>Be misleading or deceptive</li>
          </ul>

          <p style={{ marginBottom: '0.5rem' }}>We reserve the right to:</p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Reject or remove usernames that violate these terms</li>
            <li>Reclaim inactive usernames after 12 months</li>
            <li>Require username changes if necessary</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>2.3 Account Security</h3>
          <p style={{ marginBottom: '0.5rem' }}>You agree to:</p>
          <ul style={{ marginBottom: '2rem', paddingLeft: '1.5rem' }}>
            <li>Maintain the security of your device</li>
            <li>Not share your account with others</li>
            <li>Notify us immediately of unauthorized access</li>
            <li>Be responsible for all activity under your account</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>3. Acceptable Use Policy</h2>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>3.1 Permitted Uses</h3>
          <p style={{ marginBottom: '0.5rem' }}>You may use Artrix to:</p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Create artwork for personal or commercial use</li>
            <li>Share your creations publicly</li>
            <li>Download and save your generated images</li>
            <li>Use generated art in your projects (subject to OpenAI's usage policy)</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>3.2 Prohibited Uses</h3>
          <p style={{ marginBottom: '0.5rem' }}>You may NOT:</p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Generate illegal, harmful, or offensive content</li>
            <li>Create content that violates others' rights (copyright, trademark, etc.)</li>
            <li>Harass, threaten, or harm other users</li>
            <li>Use the App for spam or malicious purposes</li>
            <li>Attempt to hack, reverse engineer, or exploit the App</li>
            <li>Circumvent usage limits or payment requirements</li>
            <li>Create fake accounts or manipulate engagement (fake likes)</li>
            <li>Scrape or extract data from the App</li>
            <li>Use the App to train competing AI models</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>3.3 Content Restrictions</h3>
          <p style={{ marginBottom: '0.5rem' }}>Generated content must NOT include:</p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Nudity, sexual content, or pornography</li>
            <li>Violence, gore, or graphic content</li>
            <li>Hate speech, discrimination, or harassment</li>
            <li>Illegal activities or drugs</li>
            <li>Personal information of others (doxxing)</li>
            <li>Copyrighted characters or logos (without permission)</li>
            <li>Misleading deepfakes or impersonations</li>
            <li>Content targeting children inappropriately</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>3.4 Enforcement</h3>
          <p style={{ marginBottom: '0.5rem' }}>We reserve the right to:</p>
          <ul style={{ marginBottom: '2rem', paddingLeft: '1.5rem' }}>
            <li>Remove content that violates these terms</li>
            <li>Suspend or terminate accounts for violations</li>
            <li>Report illegal activity to authorities</li>
            <li>Limit or restrict features for abusive users</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>4. Intellectual Property Rights</h2>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>4.1 Your Generated Content</h3>
          <p style={{ marginBottom: '0.5rem' }}><strong>Ownership:</strong></p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>You own the output images generated through the App</li>
            <li>Subject to OpenAI's usage terms (<a href="https://openai.com/policies/terms-of-use" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent-color)' }}>https://openai.com/policies/terms-of-use</a>)</li>
            <li>You grant us a license to display shared content (see 4.2)</li>
          </ul>

          <p style={{ marginBottom: '0.5rem' }}><strong>Usage Rights - You can:</strong></p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Use generated images for personal projects</li>
            <li>Use generated images for commercial purposes</li>
            <li>Modify, edit, or incorporate images into your work</li>
            <li>Sell or license your generated artwork</li>
          </ul>

          <p style={{ marginBottom: '0.5rem' }}><strong>Restrictions - You cannot:</strong></p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Claim sole authorship without acknowledging AI assistance (where required)</li>
            <li>Use images to train competing AI models</li>
            <li>Generate images of real people without permission</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>4.2 License to Shared Content</h3>
          <p style={{ marginBottom: '0.5rem' }}>When you share artwork publicly, you grant Artrix:</p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Non-exclusive, worldwide, royalty-free license</li>
            <li>Right to display, reproduce, and distribute</li>
            <li>Right to use in marketing materials (with credit)</li>
            <li>Sublicensable to other users for viewing/liking</li>
          </ul>

          <p style={{ marginBottom: '0.5rem' }}>You can:</p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Revoke this license by unsharing/deleting the artwork</li>
            <li>Continue using your artwork however you want</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>4.3 Artrix's Intellectual Property</h3>
          <p style={{ marginBottom: '0.5rem' }}>We own all rights to:</p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>The Artrix app, design, and code</li>
            <li>Artrix branding, logos, and trademarks</li>
            <li>App interface and user experience</li>
            <li>Documentation and marketing materials</li>
          </ul>

          <p style={{ marginBottom: '0.5rem' }}>You may NOT:</p>
          <ul style={{ marginBottom: '2rem', paddingLeft: '1.5rem' }}>
            <li>Copy, modify, or reverse engineer the App</li>
            <li>Use our trademarks without permission</li>
            <li>Create derivative apps based on Artrix</li>
            <li>Remove or obscure copyright notices</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>5. Subscriptions and Payments</h2>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>5.1 Free Usage</h3>
          <p style={{ marginBottom: '0.5rem' }}>Free users receive:</p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Limited number of image generations (as displayed in app)</li>
            <li>Access to basic art styles</li>
            <li>Local gallery storage</li>
            <li>Public gallery viewing</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>5.2 Premium Subscriptions</h3>
          <p style={{ marginBottom: '0.5rem' }}>Premium subscriptions include:</p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Unlimited image generations</li>
            <li>Access to all art styles</li>
            <li>Priority processing</li>
            <li>Higher resolution outputs (if available)</li>
            <li>No ads (if we introduce ads)</li>
          </ul>

          <p style={{ marginBottom: '1rem' }}>Subscription plans and pricing are displayed within the app and may vary by region.</p>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>5.3 Payment Terms</h3>
          <p style={{ marginBottom: '0.5rem' }}><strong>Processing:</strong></p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>All payments processed through Apple App Store</li>
            <li>Prices shown in your local currency</li>
            <li>Taxes may apply based on your location</li>
          </ul>

          <p style={{ marginBottom: '0.5rem' }}><strong>Billing:</strong></p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Subscriptions auto-renew unless cancelled</li>
            <li>Charged to your Apple ID account</li>
            <li>Renewal occurs 24 hours before period ends</li>
            <li>Manage via Apple App Store settings</li>
          </ul>

          <p style={{ marginBottom: '0.5rem' }}><strong>No Refunds:</strong></p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>All sales are final (per Apple's policy)</li>
            <li>Contact Apple for refund requests</li>
            <li>Exceptions: legal requirements or service failure</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>5.4 Cancellation</h3>
          <p style={{ marginBottom: '0.5rem' }}>You can cancel anytime:</p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Settings → Subscriptions (in iOS)</li>
            <li>Cancel at least 24 hours before renewal</li>
            <li>Access continues until period ends</li>
            <li>No prorated refunds for partial periods</li>
          </ul>

          <p style={{ marginBottom: '0.5rem' }}>We may cancel/suspend for:</p>
          <ul style={{ marginBottom: '2rem', paddingLeft: '1.5rem' }}>
            <li>Terms of Service violations</li>
            <li>Payment fraud or chargebacks</li>
            <li>Abusive behavior</li>
            <li>Illegal activity</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>6. Content Moderation</h2>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>6.1 Automated Filtering</h3>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>AI prompts are filtered for inappropriate content</li>
            <li>OpenAI's content policy is enforced</li>
            <li>Some prompts may be blocked or modified</li>
            <li>Appeals: contact info@rapidnova.co</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>6.2 User Reports</h3>
          <p style={{ marginBottom: '0.5rem' }}>Users can report:</p>
          <ul style={{ marginBottom: '1rem', paddingLeft: '1.5rem' }}>
            <li>Inappropriate public artworks</li>
            <li>Offensive usernames</li>
            <li>Copyright violations</li>
            <li>Spam or abusive behavior</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>6.3 Our Response</h3>
          <p style={{ marginBottom: '0.5rem' }}>We will:</p>
          <ul style={{ marginBottom: '2rem', paddingLeft: '1.5rem' }}>
            <li>Review reports within 48 hours</li>
            <li>Remove violating content</li>
            <li>Issue warnings to users</li>
            <li>Suspend/ban repeat offenders</li>
            <li>Notify reporters of outcomes (when appropriate)</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>7. Disclaimers and Limitations</h2>

          <p style={{ marginBottom: '1rem' }}>
            THE APP IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, ACCURACY OR RELIABILITY OF AI OUTPUTS, OR UNINTERRUPTED OR ERROR-FREE OPERATION.
          </p>

          <p style={{ marginBottom: '2rem' }}>
            We are not responsible for OpenAI service interruptions, Firebase downtime, Apple App Store issues, Internet connectivity problems, user-generated content, interactions between users, or copyright issues with user content.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>8. Limitation of Liability</h2>

          <p style={{ marginBottom: '1rem' }}>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, our total liability is limited to the amount you paid us in the last 12 months (maximum liability: $100 or amount paid, whichever is less). We are not liable for indirect, incidental, or consequential damages, loss of data or content, loss of profits or revenue, business interruption, or third-party actions.
          </p>

          <p style={{ marginBottom: '2rem' }}>
            You agree to indemnify and hold us harmless from claims arising from your use of the App, violations of these Terms, infringement of third-party rights, your generated content, and your interactions with other users.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>9. Termination</h2>

          <p style={{ marginBottom: '0.5rem' }}>You can stop using Artrix anytime by uninstalling the app, cancelling your subscription, or requesting account deletion.</p>

          <p style={{ marginBottom: '0.5rem' }}>We may suspend or terminate your access for Terms of Service violations, illegal activity, abusive behavior, non-payment or payment fraud, extended inactivity (after notice), or legal requirements.</p>

          <p style={{ marginBottom: '2rem' }}>
            Upon termination, your access is immediately revoked. Local data remains on your device until uninstall. Public content may remain (request deletion if desired). No refunds for remaining subscription period. We may delete your account data after 30 days.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>10. Dispute Resolution</h2>

          <p style={{ marginBottom: '1rem' }}>
            Before filing a claim, contact us at info@rapidnova.co with a detailed description of the issue. We'll respond within 30 days and attempt good-faith resolution.
          </p>

          <p style={{ marginBottom: '1rem' }}>
            If informal resolution fails, disputes will be resolved through binding arbitration. You agree to resolve disputes individually (no class actions, no class arbitrations, no representative actions).
          </p>

          <p style={{ marginBottom: '2rem' }}>
            These Terms are governed by the laws of Singapore without regard to conflict of law principles.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>11. Changes to Terms</h2>

          <p style={{ marginBottom: '1rem' }}>
            We may modify these Terms to comply with legal requirements, reflect service changes, or for business reasons. We'll notify you of material changes by updating the "Last Updated" date, in-app notification, and email (if we have it) 30 days before the effective date.
          </p>

          <p style={{ marginBottom: '2rem' }}>
            Continued use after changes constitutes acceptance. If you disagree, stop using the App, cancel your subscription, and contact us with concerns.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>12. Contact Information</h2>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>General Support</h3>
          <p style={{ marginBottom: '1.5rem' }}>
            <strong>Email:</strong> info@rapidnova.co<br/>
            <strong>In-App:</strong> Settings → Help & Support
          </p>

          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.75rem', color: 'inherit' }}>Business Address</h3>
          <p style={{ marginBottom: '2rem' }}>
            RapidNova<br/>
            60 Paya Lebar Road, #07-54<br/>
            Paya Lebar Square<br/>
            Singapore 409051
          </p>

          <hr style={{ margin: '3rem 0', border: 'none', borderTop: '1px solid #eee' }} />

          <p style={{ marginBottom: '1rem', fontStyle: 'italic' }}>
            <strong>Thank you for using Artrix!</strong>
          </p>

          <p style={{ marginBottom: '0', fontSize: '0.9rem', color: '#666', fontStyle: 'italic' }}>
            These Terms of Service were last updated on October 10, 2025. Please review regularly for updates.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ArtrixTermsOfService;
